import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	data: [],
	loaded: false,
	fetching: false,
}

const libVoiceOverCategories = createSlice({
	name: 'LIB/VOICEOVER/CATEGORIES',
	initialState,
	reducers: {
		setCategories(state, { payload: categories }) {
			if (Array.isArray(categories)) {
				state.data = categories
				state.loaded = true
				state.fetching = false
			}
		},

		fetching(state, { payload }) {
			state.fetching = payload
		},

		loaded(state, { payload }) {
			state.loaded = payload
		},
	},
})

export const { setCategories, fetching, loaded } = libVoiceOverCategories.actions

export default libVoiceOverCategories.reducer
